import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PageTemplateService } from '../services/page-template.service';

export const PageTemplateEditResolver: ResolveFn<any> = async (route) => {
  const id = route.paramMap.get('id');
  try {
    return await inject(PageTemplateService).getBreadCrumbPageTemplateEdit(id);
  } catch {
    return [];
  }
};
